import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

export const LabelWithCheckbox = ({ label, checkboxLabel, checked, onChange, isNotMandatory = false }) => (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <Typography variant="body2">
            {label}
            <span className="text-error">{isNotMandatory ? "" : "*"}</span>
        </Typography> 
        <FormControlLabel
            control={<Checkbox checked={checked} onChange={onChange} size="small" />}
            label={checkboxLabel}
            sx={{ margin: '-12px' }}
        />
    </Box>
);